var WDN = WDN || {};

if (typeof WDN.ProductGallery === "undefined") {
  WDN.ProductGallery = (function () {
    var Gallery;

    Gallery = function (config) {
      this.nodes = {
        container: document.querySelector(config.selector),
        scrollContainer: document.querySelector(config.selector + ' [data-productgallery-scroller]'),
        thumbButtons: document.querySelectorAll(config.selector + ' [data-productgallery-thumb-button]'),
      };

      this.videos = {
        gallery: Array.from(document.querySelectorAll(config.selector + " .gallery-video")),
        scroller: Array.from(document.querySelectorAll(config.selector + " .thumbnail-video")),
      };

      this.init();
    };

    Gallery.prototype.assignNodes = function () {
      this.nodes.mainContainer = this.nodes.container.querySelector("[data-gallery-main]");
      this.nodes.mainImage = this.nodes.mainContainer.querySelector("img");
      // contains all thumbs
      this.nodes.thumbs = Array.from(this.nodes.container.querySelectorAll("[data-gallery-thumb]"));
      // contains only image thumbs - used for preloading
      this.nodes.imageThumbs = this.getThumbsByType("image");

    };

    Gallery.prototype.getThumbsByType = function (type) {
      return this.nodes.thumbs.filter(function (thumb) {
        return thumb.getAttribute("data-thumb-type") === type;
      });
    };

    Gallery.prototype.preloadImages = function () {
      this.nodes.imageThumbs.forEach(function (thumb) {
        var image = new Image();
        image.src = thumb.getAttribute("data-gallery-thumb");
      });
    };

    Gallery.prototype.setMainImageSrc = function (newSrc, newSrcSet) {
      if (!newSrc) return;
      this.nodes.mainImage.src = newSrc;
      this.nodes.mainImage.srcset = newSrc;
    };

    Gallery.prototype.handleThumbClick = function (e) {
      var clickedThumb = e.currentTarget;
      var clickedThumbSrc = clickedThumb.getAttribute("data-gallery-thumb");
      var clickedThumbSrcSet = clickedThumb.getAttribute("data-gallery-thumb-srcset");
      var clickedThumbType = clickedThumb.getAttribute("data-thumb-type");
      
      var srcMode = "image";

      // Thumb highlight
      var allThumb = document.querySelectorAll(".product_gallery-thumb");
      
      allThumb.forEach(function (thumb) {
        var img = thumb.querySelector("img");
        
        if (thumb == clickedThumb) {
          img.classList.add("product__thumb-selected");
        } else {
          img.classList.remove("product__thumb-selected");
        }
      })
      // Thumb highlight end
      
      // Pause and reset unrelated videos
      this.pauseVideos(this.videos.gallery);

      switch (clickedThumbType) {
        case "image":
          relatedGalleryVideo = false;
          this.setMainImageSrc(clickedThumbSrc, clickedThumbSrcSet);
          break;
        case "video":
          srcMode = "video";
          
          relatedGalleryVideo = this.videos.gallery.find(video => video.id === clickedThumb.dataset.relatedVideoId);
          
          if (relatedGalleryVideo) {
            relatedGalleryVideo.classList.add("active-gallery-video");
          }
          break;
        case "external_video":
          // handle external video src
          break;
      }

      this.nodes.container.setAttribute("data-gallery-mode", srcMode);
    };

    Gallery.prototype.pauseVideos = function(videos) {
      if (videos && videos.length > 0) {
        videos.forEach(video => {
          video.querySelector("video").pause();
          
          if (video.classList.contains("active-gallery-video")) {
            video.classList.remove("active-gallery-video");
          }
        });
      }
    }
    
    Gallery.prototype.bindPauseVideoOnScroll = function() {
      const deviceIsMobile = 768 > window.innerWidth;

      if (deviceIsMobile) {
        this.nodes.scrollContainer.addEventListener('scroll', () => {
          this.pauseVideos(this.videos.scroller);
        }); 
      }
    }

    Gallery.prototype.handleThumbButtonClick = function(e) {
      var clickedThumbButton = e.currentTarget;
      var thumbButtonIndex = Number(clickedThumbButton.dataset.productgalleryThumbButton);
      if (isNaN(thumbButtonIndex)) return;
      var imageWidth = this.nodes.scrollContainer.querySelector('[data-gallery-thumb]').offsetWidth;
      this.nodes.scrollContainer.scrollTo({top: 0,left: imageWidth * thumbButtonIndex,behavior: "smooth",});
    }

    Gallery.prototype.bind = function () {
      this.nodes.thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", this.handleThumbClick.bind(this));
      }, this);

      if(this.nodes.scrollContainer && this.nodes.thumbButtons) {
        this.nodes.thumbButtons.forEach(btn => btn.addEventListener('click', this.handleThumbButtonClick.bind(this)));
      }

      this.bindPauseVideoOnScroll();
    };

    Gallery.prototype.init = function () {
      if (!this.nodes.container) return;
      this.assignNodes();
      this.preloadImages();
      this.bind();
    };

    return Gallery;
  })();
}

new WDN.ProductGallery({
  selector: "[data-gallery]",
});
